import { useTranslation } from 'react-i18next';

import { useSaleOptions } from '@/hooks';
import { Table } from '@tanstack/react-table';
import { OpportunityItemList } from '@/features/opportunities/types';
import { TableFilterDropdown } from './table-filter-dropdown';

export type DealTypeFilterProps = {
  readonly table: Table<OpportunityItemList>;
  readonly value?: string[];
  readonly onChange: (value: string[]) => void;
  readonly popoverFilter?: boolean;
};

export function DealTypeFilter({ table, value, onChange, popoverFilter }: DealTypeFilterProps) {
  const { t } = useTranslation(['home']);

  const { options: dealType } = useSaleOptions();

  return (
    <TableFilterDropdown
      column={table.getColumn('options')!}
      title={t('Deal Type')}
      options={dealType}
      value={value}
      onChange={onChange}
      popoverFilter={popoverFilter}
    />
  );
}
